// Fuel Efficiency units with conversion factors (various base units)
export const fuelEfficiencyUnits = [
  { id: 'kilometers-per-liter', name: 'Kilometer/Liter', symbol: 'km/L', plural: 'Kilometers/Liter', factor: 1 },
  { id: 'liters-per-100km', name: 'Liter/100 Kilometers', symbol: 'L/100km', plural: 'Liters/100 Kilometers', factor: 'inverse100' },
  { id: 'miles-per-gallon-us', name: 'Mile/Gallon (US)', symbol: 'mpg', plural: 'Miles/Gallon (US)', factor: 0.425143707 },
  { id: 'miles-per-gallon-uk', name: 'Mile/Gallon (UK)', symbol: 'mpg', plural: 'Miles/Gallon (UK)', factor: 0.354006044 },
  { id: 'miles-per-liter', name: 'Mile/Liter', symbol: 'mi/L', plural: 'Miles/Liter', factor: 0.621371192 },
  { id: 'kilometers-per-gallon-us', name: 'Kilometer/Gallon (US)', symbol: 'km/gal', plural: 'Kilometers/Gallon (US)', factor: 0.264172052 },
  { id: 'meters-per-liter', name: 'Meter/Liter', symbol: 'm/L', plural: 'Meters/Liter', factor: 1000 },
  { id: 'nautical-miles-per-liter', name: 'Nautical Mile/Liter', symbol: 'nmi/L', plural: 'Nautical Miles/Liter', factor: 0.539956803 },
];

export const popularFuelEfficiencyConversions = [
  { from: 'miles-per-gallon-us', to: 'liters-per-100km' },
  { from: 'liters-per-100km', to: 'miles-per-gallon-us' },
  { from: 'kilometers-per-liter', to: 'miles-per-gallon-us' },
  { from: 'miles-per-gallon-us', to: 'kilometers-per-liter' },
  { from: 'miles-per-gallon-us', to: 'miles-per-gallon-uk' },
  { from: 'kilometers-per-liter', to: 'liters-per-100km' },
];

export const getUnitById = (id) => fuelEfficiencyUnits.find(unit => unit.id === id);

export const convertFuelEfficiency = (value, fromId, toId) => {
  // Handle special case of L/100km which is inverse
  if (fromId === 'liters-per-100km') {
    // Convert from L/100km to km/L first
    const kmPerL = 100 / value;
    if (toId === 'liters-per-100km') return value;
    const toUnit = getUnitById(toId);
    if (!toUnit) return null;
    return kmPerL * toUnit.factor;
  }

  if (toId === 'liters-per-100km') {
    // First convert to km/L
    const fromUnit = getUnitById(fromId);
    if (!fromUnit) return null;
    const kmPerL = value / fromUnit.factor;
    return 100 / kmPerL;
  }

  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value / fromUnit.factor; // Convert to km/L
  return baseValue * toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
